import { saveAs } from 'file-saver';

const saveFile = ({ url, fileName }) => {
  saveAs(url, fileName);
};

export { saveFile };
